import React from 'react'
import firebase from 'firebase/compat/app'
import 'firebase/compat/remote-config'
import APIManager from '../util/apiManager'
import Sentry from '../util/sentry'

import { WithErrorContext } from './errorContext'
import { WithRouterContext } from './routerContext.js'

import { getJid, getDeviceInfoBasedOnBrowser } from '../util/utilitys'
import { buildNumber, version } from '../constants/buildNumber.json'
import { AMPLITUDE_LOCALSTORAGE_KEY } from '../constants'
import LocalStorageManager from '../util/localStorageManager.js'
import UserPreferenceManager from '../util/userPreferenceManager'
import FirebaseAuthManager from '../fronted-share-components/src/utils/firebaseAuthManager.js'
import FirebaseEventManager from '../fronted-share-components/src/utils/firebaseEventManager.js'
import AmplitudeEventManager from '../fronted-share-components/src/utils/amplitudeEventManager.js'

// @ts-ignore
export const DeviceContext = React.createContext()

const localStorageManager = LocalStorageManager.getInstance()

const storeColumnList = [
    'idToken',
    'refreshToken',
    'email',
    'owner',
    'zoomInLock',
    'clickX',
    'clickY',
    'isZoom',
    'zoomMode',
    'zoomScale',
]
class _DeviceProvider extends React.Component {
    // @ts-ignore
    constructor(props) {
        super(props)
        const { osVersion, vendor, deviceName, device } =
            getDeviceInfoBasedOnBrowser()

        const remoteConfig = firebase.remoteConfig()
        remoteConfig.defaultConfig = {
            EnableSentry: false,
        }

        if (window.env !== 'prod') {
            remoteConfig.settings.minimumFetchIntervalMillis = 1000
        }

        // @ts-ignore
        this.state = {
            idToken: '',
            isFree: true,
            isPremium: false,
            featureSource: 'login',
            xmpp: {
                addr: '',
            },
            status: 'offline',
            kvToken: '',
            jid: '',
            email: '',
            deviceId: '',
            uniqueId: '',
            deviceName: device, // name of the physical device
            label: deviceName, // camera alias
            owner: {
                name: '',
                fname: '',
                lname: '',
                picture: '',
                lang: '',
            },
            groupId: null,
            appversion: buildNumber,
            app: {
                build: buildNumber,
                version,
            },
            clickX: 0,
            clickY: 0,
            isZoom: false,
            zoomMode: 1,
            zoomScale: 1,

            os: 'web',
            // @ts-ignore
            osversion: osVersion,
            // @ts-ignore
            vendor: vendor,

            eventPreferences: null,

            remoteConfig,
            isLogin: false,
            mutations: {
                unsetZoomInLock: this.unsetZoomInLock,
                updateStatus: this.updateStatus.bind(this),
                onSignInSuccess: this.handleError.call(
                    this,
                    this.onSignInSuccess.bind(this)
                ),
                initialCamera: this.handleError.call(
                    this,
                    this.initialCamera.bind(this)
                ),
                createEventWithSnapshot: this.handleError.call(
                    this,
                    this.createEventWithSnapshot.bind(this)
                ),
                onMotionDetected: this.handleError.call(
                    this,
                    this.onMotionDetected.bind(this)
                ),
                onCreateEventSuccess: this.handleError.call(
                    this,
                    this.onCreateEventSuccess.bind(this)
                ),
                onLoadEventbookSuccess: this.handleError.call(
                    this,
                    this.onLoadEventbookSuccess.bind(this)
                ),
                onTutorialsUpdated: this.handleError.call(
                    this,
                    this.onTutorialsUpdated.bind(this)
                ),
                attachVideoToEvent: this.handleError.call(
                    this,
                    this.attachVideoToEvent.bind(this)
                ),
                reloadFeature: this.handleError.call(
                    this,
                    this.reloadFeature.bind(this)
                ),
                signOut: this.handleError.call(this, this.signOut.bind(this)),
                forceZoomOut: this.handleError.call(
                    this,
                    this.forceZoomOut.bind(this)
                ),
                // loginByRefreshToken: this.handleError.call(this, this.loginByRefreshToken.bind(this)),
            },
        }

        const storeCameraSettings = {}
        storeColumnList.forEach((key) => {
            storeCameraSettings[key] = localStorageManager.cameraSettings[key]
        })
        this.state = Object.assign(
            {},
            this.state,
            storeCameraSettings,
            localStorageManager.deviceSettings
        )
        this.apiManager = APIManager.getInstance()
        this.apiManager.observable.subscribe(this.handleAPIError)
    }

    handleAPIError = ({ type }) => {
        if (type === 'FORCE_SIGN_OUT') {
            this.signOut()
        }
    }

    forceZoomOut = () => {
        this.updateStatus({
            clickX: 0,
            clickY: 0,
            zoomMode: 0,
            zoomScale: 1,
            isZoom: false,
        })
    }
    unsetZoomInLock = () => {
        this.updateStatus({
            zoomInLock: false,
        })
    }

    updateStatus(updateObject) {
        this.setState(updateObject, this.setSettingsCache)
    }

    setSettingsCache = () => {
        let updateObj = {}
        storeColumnList.forEach((key) => {
            updateObj[key] = this.state[key]
        })
        localStorageManager.setSettingsCache({
            type: 'device',
            updateObj,
        })
    }

    handleError(fn) {
        const apiErrorList = ['NetworkError', 'APIServerError']
        return async (...args) => {
            try {
                const result = await fn(...args)
                const error = this.props.errorContext.currentErrorMessage
                if (error && apiErrorList.includes(error.errorKey)) {
                    this.props.errorContext.closeCurrentErrorMessage()
                }
                return result
            } catch (error) {
                window.logManager.error('[API Error]', error)
                this.props.errorContext.pushErrorMessage({
                    errorKey: error,
                })
            }
        }
    }

    async reloadSentry({ uniqueId }) {
        const { remoteConfig, email, jid } = this.state
        await remoteConfig.fetchAndActivate()
        const sentryEnabled = remoteConfig.getBoolean('EnableSentry')
        if (sentryEnabled) {
            Sentry.enable({ email, uniqueId, jid: jid.split('/')[1] })
        } else {
            Sentry.disable()
        }
    }

    // Reload once per 12 hours in production and reload once per 1 min in others
    async reloadFeature() {
        const { idToken, jid } = this.state

        const {
            uniqueId,
            xmpp,
            hashState: isFree,
            eventStorageConfig,
        } = await this.apiManager.createUser({
            idToken,
        })
        await this.reloadSentry({ uniqueId })

        const deviceData = await this.apiManager.getDeviceData()

        this.setState({
            label: deviceData?.data?.label || this.state.label,
            uniqueId,
            xmpp,
            isFree,
            eventStorageConfig,
            featureSource: 'reload',
        })

        return isFree
    }

    async initialCamera() {
        const {
            jid,
            appversion,
            app,
            os,
            osversion,
            deviceName,
            label,
            vendor,
        } = this.state

        let success = false

        try {
            await this.apiManager.registerDevice({
                deviceName,
                jid,
                appversion,
                app,
                os,
                osversion,
                vendor,
            })

            const deviceData = await this.apiManager.getDeviceData(jid)
            const savedLabel = deviceData?.data?.label
            if (savedLabel && savedLabel !== label) {
                this.setState({
                    label: savedLabel,
                })
            }
            success = true
        } catch (error) {
            throw error
        } finally {
            const hasInitialCamera =
                localStorageManager.getAmplitudeEventRecord(
                    AMPLITUDE_LOCALSTORAGE_KEY.HAS_INITIAL_CAMERA
                )
            if (!hasInitialCamera) {
                AmplitudeEventManager.registeredCamera({ success })
                if (success) {
                    localStorageManager.setAmplitudeEventRecord({
                        hasInitialCamera: true,
                    })
                }
            }
        }
    }

    async initUserPreferences(jid) {
        const manager = UserPreferenceManager.getInstance()
        const eventPreferences = (await manager.fetchEventPreferences(jid)) || {
            jid,
        }
        let cameraPreferences = await manager.fetchCameraPreferences(jid)
        if (!cameraPreferences || !cameraPreferences.tutorialsStep) {
            const step = localStorageManager.cameraSettings['newLogin'] ? 0 : -1
            cameraPreferences = {
                ...cameraPreferences,
                jid,
                tutorialsStep: step,
            }
            await manager.updateTutorials(cameraPreferences, step)
        }
        this.setState({
            eventPreferences,
            cameraPreferences,
        })
    }

    // @ts-ignore
    async onSignInSuccess({ idToken, profileObj, firebaseUid }) {
        const { email, name, familyName, givenName, imageUrl } = profileObj

        const lang = window.navigator.language

        try {
            const deviceId = localStorageManager.deviceSettings.deviceId
            const { kvToken, jid } = await this.apiManager.restoreToken({
                idToken,
                firebaseUid,
                resource: deviceId,
                email,
            })

            this.setState({
                idToken,
                kvToken,
                jid,
                email,
                owner: {
                    name,
                    fname: givenName,
                    lname: familyName,
                    picture: imageUrl,
                    lang,
                },
            })

            const logInfo = {
                kvToken,
                email,
                name,
                fname: givenName,
                lname: familyName,
                picture: imageUrl,
                lang,
            }
            localStorageManager.setSettingsCache({
                type: 'camera',
                updateObj: {
                    email,
                    owner: {
                        name,
                        fname: givenName,
                        lname: familyName,
                        picture: imageUrl,
                        lang,
                    },
                },
            })
            await this.login(logInfo)

            await this.initUserPreferences(jid)

            return true
        } catch (error) {
            window.logManager.error('[Login] onSignInSuccess:', error)
            if (error === 'APIServerError') {
                return this.props.errorContext.pushErrorMessage({
                    errorKey: 'APIServerError',
                    action2: () => {
                        window.location.reload()
                    },
                })
            }
            if (error === 'NetworkError') {
                return this.props.errorContext.pushErrorMessage({
                    errorKey: 'NetworkError',
                })
            }
            this.props.errorContext.pushErrorMessage({
                errorKey: 'SignInFail',
            })

            // @ts-ignore
            this.signOut()
            return error
        }
    }

    async login({ kvToken, email, name, fname, lname, picture, lang }) {
        const { jid } = this.state
        let {
            uniqueId,
            xmpp,
            hasp: isPremium,
            hashState: isFree,
            eventStorageConfig,
            new: isSignup,
        } = await this.apiManager.createUser({
            email,
            name,
            fname,
            lname,
            picture,
            lang,
        })
        await this.reloadSentry({ uniqueId })

        const { register_date } = await this.apiManager.getUser()
        AmplitudeEventManager.setResgisterDate(register_date)

        window.eventManager.registerDeviceSuccess()

        this.setState({
            uniqueId,
            xmpp,
            isFree,
            isPremium,
            status: 'online',
            isLogin: true,
            eventStorageConfig,
            featureSource: 'login',
        })

        const firebaseEventManager = new FirebaseEventManager()
        firebaseEventManager.setUserProperties({
            uniqueId,
            deviceModel: 'Chrome',
            isFree,
            role: 'camera',
            groupId: localStorageManager.deviceSettings.groupId,
            buildNumber,
            version,
        })

        const alreadySignIn = localStorageManager.getAmplitudeEventRecord(
            AMPLITUDE_LOCALSTORAGE_KEY.ALREADY_SIGN_IN
        )
        const subscriber = isFree ? '' : isPremium ? 'premium' : 'plus'
        AmplitudeEventManager.setUserProperties({ uniqueId, subscriber })
        AmplitudeEventManager.setDefaultEventProperties({ jid })
        if (!alreadySignIn) {
            AmplitudeEventManager.signInSuccess({ success: true, isSignup })
            localStorageManager.setAmplitudeEventRecord({
                alfredAlreadySignIn: true,
            })
        }

        localStorageManager.setSettingsCache({
            type: 'device',
            updateObj: {
                isFirstSignIn: false,
            },
        })
    }

    async attachVideoToEvent({
        // @ts-ignore
        eventId,
        // @ts-ignore
        videoName,
        // @ts-ignore
        videoData,
        // @ts-ignore
        vsize,
        // @ts-ignore
        duration,
        type,
        vidType,
    }) {
        const { deviceName, label } = this.state

        await this.apiManager.attachVideoToEvent({
            device: deviceName,
            label,
            eventId,
            videoName,
            videoData,
            vsize,
            duration,
            type,
            vidType,
        })
    }

    async createEventWithSnapshot({
        // @ts-ignore
        snapshotData,
        // @ts-ignore
        snapshotName,
        type,
        vidType,
    }) {
        const {
            jid,
            appversion,
            deviceName,
            label,
            eventStorageConfig,
            isFree,
        } = this.state
        const storageConfig =
            Array.isArray(eventStorageConfig) && eventStorageConfig.length > 1
                ? isFree
                    ? eventStorageConfig[0]
                    : eventStorageConfig[1]
                : null
        const payload = {
            jid,
            device: deviceName,
            label,
            version: appversion,
            snapshotData,
            snapshotName,
            type,
            vidType,
        }
        if (typeof storageConfig === 'number') {
            payload.serviceType = isFree ? 1 : 2
            payload.storageDuration = storageConfig
        }
        const mid = await this.apiManager.createEventWithSnapshot(payload)

        return mid
    }

    async onMotionDetected() {
        const { cameraPreferences } = this.state
        if (cameraPreferences?.tutorialsStep === 1) {
            this.props.errorContext.pushErrorMessage({
                errorKey: 'motionDetected',
            })
        }
    }

    async onCreateEventSuccess(eventId, type, eventTimestamp) {
        const manager = UserPreferenceManager.getInstance()
        const { eventPreferences } = this.state
        if (!eventPreferences) return
        await manager.updateLastEventCreatedAt(eventPreferences, eventTimestamp)
        this.setState({
            eventPreferences: {
                ...eventPreferences,
                lastEventCreatedAt: eventTimestamp,
            },
        })
    }

    async onLoadEventbookSuccess() {
        const manager = UserPreferenceManager.getInstance()
        const { eventPreferences } = this.state
        if (!eventPreferences) return
        const timestamp = Date.now()
        await manager.updateLastEventbookSeenAt(eventPreferences, timestamp)
        this.setState({
            eventPreferences: {
                ...eventPreferences,
                lastEventbookSeenAt: timestamp,
            },
        })
    }

    async onTutorialsUpdated(currStep) {
        const manager = UserPreferenceManager.getInstance()
        const { cameraPreferences } = this.state
        if (!cameraPreferences) return
        await manager.updateTutorials(cameraPreferences, currStep)
        this.setState({
            cameraPreferences: {
                ...cameraPreferences,
                tutorialsStep: currStep,
            },
        })
    }

    signOut() {
        localStorageManager.clear('camera')
        localStorageManager.clear('officialWebsite')
        localStorageManager.clearAmplitudeEventKey()
        this.props.errorContext.closeCurrentErrorMessage()
        this.forceZoomOut()
        this.unsetZoomInLock()
        const firebaseAuthManager = new FirebaseAuthManager()
        firebaseAuthManager.signOut()
        this.props.routerContext.setPath('')
        const firebaseEventManager = new FirebaseEventManager()
        firebaseEventManager.clearUserProperties()
        AmplitudeEventManager.resetUser()
    }

    render() {
        return (
            <DeviceContext.Provider value={this.state}>
                {this.props.children}
            </DeviceContext.Provider>
        )
    }
}

export const DeviceProvider = WithRouterContext(
    WithErrorContext(_DeviceProvider)
)

// @ts-ignore
export const WithDeviceContext = (Component) => (props) =>
    (
        <DeviceContext.Consumer>
            {
                // @ts-ignore
                (context) => <Component deviceContext={context} {...props} />
            }
        </DeviceContext.Consumer>
    )
